export default "__VITE_ASSET__Bkc7l_JZ__"